module.exports = __webpack_public_path__ + "img/cofnij_wyslanie_kursu.6d617971.svg";